module.exports = __webpack_public_path__ + "img/hot-water.1d89f2b7.svg";